import { useQuery } from "@tanstack/react-query";
import { apiGet, apiSend } from "../../../api/client";
import type { AgentSummary, IssuedAgent } from "../../../api/types";

export function agentsKey(entityId: string | undefined) {
  return ["entities", entityId, "agents"];
}

export function useAgents(entityId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: agentsKey(entityId),
    queryFn: async () =>
      (await apiGet<{ items: AgentSummary[] }>(`/api/entities/${entityId}/agents`)).items,
    enabled: Boolean(entityId) && enabled,
  });
}

/** The only call that ever carries the plaintext token. */
export function issueAgentToken(
  entityId: string,
  label: string,
  kind: "agent" | "push" = "agent",
): Promise<IssuedAgent> {
  // The agent body stays exactly what it was; only a push token names its kind.
  const body = kind === "agent" ? { label } : { label, kind };
  return apiSend<IssuedAgent>("POST", `/api/entities/${entityId}/agents`, body);
}

export function revokeAgent(entityId: string, agentId: string): Promise<void> {
  return apiSend<void>("DELETE", `/api/entities/${entityId}/agents/${agentId}`);
}
